export const MONTH_CALENDAR = "calendar";
export const MONTH_LAST_BANK_DAY = "last_bank_day";

function toDate(value) {
  if (value instanceof Date) return new Date(value.getFullYear(), value.getMonth(), value.getDate());
  const [year, month, day] = String(value || "").split("-").map(Number);
  if (!year || !month || !day) return new Date();
  return new Date(year, month - 1, day);
}

export function isoDate(d) {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function addDays(d, n) {
  const next = new Date(d);
  next.setDate(next.getDate() + n);
  return next;
}

function easterSunday(year) {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(year, month - 1, day);
}

function danishHolidays(year) {
  const easter = easterSunday(year);
  const days = new Set([
    isoDate(new Date(year, 0, 1)),
    isoDate(addDays(easter, -3)),
    isoDate(addDays(easter, -2)),
    isoDate(addDays(easter, 1)),
    isoDate(addDays(easter, 39)),
    isoDate(addDays(easter, 50)),
    isoDate(new Date(year, 5, 5)),
    isoDate(new Date(year, 11, 24)),
    isoDate(new Date(year, 11, 25)),
    isoDate(new Date(year, 11, 26)),
    isoDate(new Date(year, 11, 31)),
  ]);
  if (year < 2024) days.add(isoDate(addDays(easter, 26)));
  return days;
}

export function isBankDay(day) {
  const d = toDate(day);
  if (d.getDay() === 0 || d.getDay() === 6) return false;
  return !danishHolidays(d.getFullYear()).has(isoDate(d));
}

export function lastBankDay(year, month) {
  const d = new Date(year, month, 0);
  while (!isBankDay(d)) d.setDate(d.getDate() - 1);
  return d;
}

function calendarMonthBounds(on) {
  const d = toDate(on);
  const start = new Date(d.getFullYear(), d.getMonth(), 1);
  const end = new Date(d.getFullYear(), d.getMonth() + 1, 0);
  return { from: isoDate(start), to: isoDate(end) };
}

function bankMonthBounds(on) {
  const d = toDate(on);
  const close = lastBankDay(d.getFullYear(), d.getMonth() + 1);
  if (d >= close) {
    const nextClose = lastBankDay(d.getFullYear(), d.getMonth() + 2);
    return { from: isoDate(close), to: isoDate(addDays(nextClose, -1)) };
  }
  const prevClose = lastBankDay(d.getFullYear(), d.getMonth());
  return { from: isoDate(prevClose), to: isoDate(addDays(close, -1)) };
}

export function monthBounds(on, mode = MONTH_LAST_BANK_DAY) {
  return mode === MONTH_CALENDAR ? calendarMonthBounds(on) : bankMonthBounds(on);
}

export function monthKey(iso, mode = MONTH_LAST_BANK_DAY) {
  if (mode === MONTH_CALENDAR) return String(iso).slice(0, 7);
  return monthBounds(iso, mode).to.slice(0, 7);
}

export function eachDay(fromIso, toIso) {
  const days = [];
  let cursor = toDate(fromIso);
  const end = toDate(toIso);
  if (Number.isNaN(cursor.getTime()) || Number.isNaN(end.getTime()) || cursor > end) {
    return days;
  }
  while (cursor <= end) {
    days.push(isoDate(cursor));
    cursor = addDays(cursor, 1);
  }
  return days;
}
